var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paid-membership-plan-downgrade initialized"},[_vm._v("\n  "+_vm._s(_vm.before.displayLabel)+"プランから"+_vm._s(_vm.after.displayLabel)+"プランへのアップグレードが完了しました。"),_c('br'),_vm._v("\n  アップグレードした内容は、本日から適用されます。"),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }